<template>
  <div id="developer">
    <my-header activeIndex="开发套件" />
    <div class="banner">
      <div>
        <div>
          <h1>Noosphere自动驾驶开发套件</h1>
          <h2>Noosphere Autonomous Driving Develop Kit (Noosphere D-kit)</h2>
          <span @click="openVideo"></span>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      @close="closeVideo"
      width="60%"
      top="15vh"
      custom-class="my-custom-dialog"
    >
      <video-player
        class="vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      >
      </video-player>
    </el-dialog>
    <div class="suite">
      <div class="title wrapper">
        <h1>Noosphere自动驾驶开发者套件</h1>
        <p>
          Noosphere自动驾驶开发套件为高校、车企及独立开发者提供行业领先的完整自动驾驶开发平台与技术支持。套件车辆
        </p>
        <p>
          采用全仿真越野车底盘，搭载完整的乘用级传感器系统，配合高性能CPU与GPU的工业控制电脑，全面开放车辆底层与
        </p>
        <p>
          自动驾驶源代码，助力开发者完成自动驾驶系统的研究、学习与教学，同时作为个性化自动驾驶方案的参考依据。
        </p>
      </div>
      <div class="content">
        <div class="wrapper">
          <ul class="top clearfix">
            <li><img src="../../assets/images/car.png" /></li>
            <li>
              <transition name="fade" v-for="index in 14" :key="index">
                <img
                  v-show="suiteIndex === index - 1"
                  :src="require(`../../assets/images/cotentsuite${index}.png`)"
                />
              </transition>
            </li>
          </ul>
          <div class="bottom">
            <ul :class="{ active: suiteStatus, clearfix: true }">
              <li
                v-for="index in 14"
                :key="index"
                @mouseenter="suiteIndex = index - 1"
              >
                <img
                  :src="
                    suiteIndex === index - 1
                      ? require(`../../assets/images/activesuite${index}.jpg`)
                      : require(`../../assets/images/suite${index}.png`)
                  "
                />
              </li>
            </ul>
          </div>
          <i
            :class="{
              prev: true,
              'el-icon-arrow-left': true,
              disabled: !suiteStatus
            }"
            @click="suiteStatus = false"
          ></i>
          <i
            :class="{
              next: true,
              'el-icon-arrow-right': true,
              disabled: suiteStatus
            }"
            @click="suiteStatus = true"
          ></i>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="commonTitle wrapper">
        Noosphere核心优势
      </div>
      <ul class="content clearfix">
        <li
          v-for="(item, index) in advantageList"
          :key="index"
          :class="{ active: advantageIndex === index }"
          :style="
            advantageIndex === index
              ? `background:url(${require(`../../assets/images/advantage1${index +
                  1}.jpg`)});background-size: 100% 100%;`
              : `background:url(${require(`../../assets/images/advantage${index +
                  1}.jpg`)});background-size: 100% 100%;`
          "
          @mouseenter="advantageIndex = index"
        >
          <h1>0{{ index + 1 }}</h1>
          <h2>{{ item.name }}</h2>
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
          >
            <p v-show="advantageIndex === index">
              {{ item.details }}
            </p>
          </transition>
        </li>
      </ul>
    </div>
    <div class="parameter wrapper">
      <div class="commonTitle">Noosphere基础参数</div>
      <ul class="tabBar clearfix">
        <li
          v-for="(item, index) in parameterList"
          :key="index"
          :class="{ active: parameterIndex === index }"
          @click="parameterIndex = index"
        >
          {{ item.name }}
        </li>
      </ul>
      <div class="content">
        <transition
          name="fade"
          v-for="(item, index) in parameterList"
          :key="index"
        >
          <img
            v-show="parameterIndex === index"
            :src="require(`../../assets/images/parameter${index + 1}.png`)"
          />
        </transition>
      </div>
    </div>
    <div class="coreModule wrapper">
      <div class="commonTitle">核心软件模块</div>
      <ul class="content clearfix">
        <li
          v-for="(item, index) in coreModuleList"
          :key="index"
          :class="{ active: coreModuleIndex === index }"
          @mouseenter="coreModuleIndex = index"
        >
          <h1
            :style="
              `background: url(${require(`../../assets/images/coreModule${index +
                1}.jpg`)});`
            "
          >
            <span> {{ item.name }}</span>
          </h1>
          <p>{{ item.details }}</p>
        </li>
      </ul>
    </div>
    <div class="ordersuite wrapper">
      <div class="title">
        <h1>订购套件</h1>
        <p>
          感谢您对Noosphere自动驾驶开发套件的关注，请填写购买需求以便我们更快的与您联系。
        </p>
        <p>
          想了解更多，请发送邮件至noosphere_d-kit@ckzone.cn
        </p>
      </div>
      <div class="content">
        <el-form
          label-position="right"
          label-width="160px"
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <el-row>
            <el-col :span="12"
              ><el-form-item label="姓名：" prop="Name">
                <el-input
                  v-model="form.Name"
                  placeholder="请输入姓名"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12"
              ><el-form-item label="电话：" prop="Phone">
                <el-input
                  v-model="form.Phone"
                  placeholder="请输入电话号码"
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
              ><el-form-item label="邮箱：" prop="Email">
                <el-input
                  v-model="form.Email"
                  placeholder="请输入邮箱"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="12">
              <el-col :span="12">
                <el-form-item label="所属单位：" required>
                  <company-type
                    v-model="form.CompanyType"
                    @transmitDefault="value => (form.CompanyType = value)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label-width="20px" prop="CompanyName">
                  <el-input
                    v-model="form.CompanyName"
                    placeholder="请输入单位名称"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
              ><el-form-item label="购买数量：">
                <el-input-number
                  v-model="form.PuchaseCount"
                  :min="1"
                  :precision="0"
                ></el-input-number> </el-form-item
            ></el-col>
          </el-row>
        </el-form>
        <el-button
          type="primary"
          :loading="isLoading"
          @click="handleSubmit('ruleForm')"
          >提交</el-button
        >
      </div>
    </div>
    <my-footer />
  </div>
</template>

<script>
import MyHeader from "@/components/header";
import MyFooter from "@/components/footer";
import CompanyType from "@/components/companyType";
import myVideo from "@/assets/video/developerVideo.mp4";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
export default {
  name: "developer",
  data() {
    return {
      playerOptions: {
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        language: "zh-CN",
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        sources: [
          {
            type: "video/mp4", // 类型
            src: myVideo // url地址
          }
        ],
        poster: "", // 封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true // 是否显示全屏按钮
        }
      },
      suiteIndex: 0,
      suiteStatus: false,
      advantageIndex: 0,
      advantageList: [
        {
          name: "乘用级传感",
          details:
            "搭载主流车用传感器，16线激光雷达、长距离双波束毫米波雷达、超声波雷达、厘米级全球卫星导航与捷联惯性导航系统、全高清工业摄像头等"
        },
        {
          name: "高性能计算力",
          details:
            "搭载英特尔i7 CPU及英伟达GTX 1080显卡的高性能工业电脑，实现复杂神经网络推理，确保开发者能够在套件上验证或搭载当前最先进的自动驾驶算法"
        },
        {
          name: "仿真车辆底盘",
          details:
            "采用仿真越野车底盘，前后双叉臂独立悬挂，具备前轮转向机构、后轮差速器、液压弹簧减震阻尼系统，全系统线控改装，控制方式与乘用车相仿"
        },
        {
          name: "工业现场总线",
          details:
            "自动驾驶系统与线控底盘采用车用CAN总线接口连接，完全模拟真实汽车通信环境，确保在开发套件中实现的功能与算法快速移植到乘用车使用"
        },
        {
          name: "强劲动力系统",
          details:
            "套件微型车搭载动力型锂电池，支持万瓦瞬时功率输出。配合5千瓦主动力电机与2台55公斤级大扭力舵机，确保高负载作业要求"
        },
        {
          name: "开放与扩展性",
          details:
            "自动驾驶套件源代码开放，完善的技术资料，方便开发者进行二次开发及功能扩展。通过车辆顶部二次扩展口，可搭载并扩展各种传感器与控制器。"
        },
        {
          name: "快速调试环境",
          details:
            "桌面级体积的套件车辆，方便室内连接显示器直接调试算法和功能。突破室内代码编译、室外下载调试的传统方式，助力程序的快速开发验证"
        },
        {
          name: "高路测安全性",
          details:
            "避免了百公斤级自动驾驶车调试过程中易伤人、伤物、伤车的风险，配合多冗余安全机制、遥控一键接管等功能，降低安全风险与调试成本"
        }
      ],
      parameterIndex: 0,
      parameterList: [
        { name: "整车参数" },
        { name: "底盘参数" },
        { name: "上装参数" }
      ],
      coreModuleIndex: 0,
      coreModuleList: [
        {
          name: "环境感知",
          details:
            "环境感知模块识别自动驾驶车辆周围的世界，包括障碍物检测和交通灯检测。"
        },
        {
          name: "车辆定位",
          details:
            "车辆定位模块融合GNSS-RTK，IMU和激光雷达的各种信息，精确定位自动驾驶车辆的位置。"
        },
        {
          name: "轨迹预测",
          details:
            "轨迹预测模块预测感知障碍物的未来运动轨迹，并提供给路径规划模块。"
        },
        {
          name: "路由导航",
          details:
            "路由导航模块告诉自动驾驶车辆如何通过一系列车道或道路到达其目的地。"
        },
        {
          name: "路径规划",
          details:
            "路径规划模块计算自动驾驶车辆为到达其目的地，优选的时间和空间轨迹"
        },
        {
          name: "车辆控制",
          details:
            "通过产生诸如油门，制动和转向的控制命令，完成横向与纵向控制，执行路径规划模块产生的轨迹。"
        },
        {
          name: "CANBUS",
          details:
            "CanBus是将控制命令传递给车辆硬件的接口。它还将底盘信息传递给自动驾驶软件系统。"
        },
        {
          name: "高精地图",
          details:
            "该模块类似于库。用作查询引擎支持，以提供关于道路的特定结构化信息。"
        },
        {
          name: "HMI",
          details: "HMI模块用于查看车辆状态，测试其他模块以及实时控制车辆功能。"
        },
        {
          name: "监控",
          details: "监控模块用于监控车辆中所有模块的系统状态与硬件状态。"
        },
        {
          name: "安全",
          details:
            "安全模块用于干预监控检测到的失败结果，并通过操作中心进行故障干预。"
        },
        {
          name: "动力管理",
          details:
            "实时监测动力系统主要参数，在提供强进动力的同时，保证系统安全可靠运行。"
        }
      ],
      isLoading: false,
      form: {
        Name: "",
        Phone: "",
        Email: "",
        CompanyType: "",
        CompanyName: "",
        PuchaseCount: 1
      },
      rules: {
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !this.checkPhone(value) &&
                !this.checkTelephone(value)
              ) {
                return callback(new Error("必须为正确的电话号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        Email: [
          {
            validator: (rule, value, callback) => {
              if (value && !this.checkEmail(value)) {
                return callback(new Error("必须为正确的邮箱地址"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        CompanyName: [
          { required: true, message: "请输入单位名称", trigger: "blur" }
        ]
      },
      dialogVisible: false
    };
  },
  methods: {
    //校验邮箱
    checkEmail(str) {
      // eslint-disable-next-line no-useless-escape
      const reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      if (reg.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    //校验电话
    checkPhone(str) {
      if (/^1[3-9]\d{9}$/.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    checkTelephone(str) {
      if (/(^0\d{2}-\d{8}$)|(^0\d{3}-\d{7}$)/.test(str)) {
        return true;
      } else {
        return false;
      }
    },
    //提交
    handleSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.isLoading = true;
          this.loadAddOrder(formName);
        }
      });
    },
    loadAddOrder(formName) {
      this.requestApi("developer", "addOrder", this.form, res => {
        if (res.Code === 0) {
          this.$alert(res.Message);
        } else {
          this.$message.error(res.Message);
        }
        //初始化
        this.isLoading = false;
        // this.$refs[formName].resetFields()
      });
    },
    openVideo() {
      this.dialogVisible = true;
      setTimeout(() => {
        this.player.play();
      }, 100);
    },
    closeVideo() {
      this.player.pause();
    }
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  components: { MyHeader, MyFooter, CompanyType, videoPlayer }
};
</script>

<style lang="less">
#developer {
  .banner {
    position: relative;
    width: 100%;
    padding-top: 34.6%;
    background: url("../../assets/images/developerbanner.gif");
    background-size: 100% 100%;
    > div {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      font-size: 10px;
      background: rgba(0, 0, 0, 0.8);
      > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 600px;
        height: 187px;
        h1 {
          color: #fff;
          text-align: center;
          font-size: 40px;
          font-weight: bold;
          letter-spacing: 3px;
        }
        h2 {
          line-height: 26px;
          font-size: 20px;
          color: #fff;
          text-align: center;
        }
        span {
          display: block;
          width: 85px;
          height: 85px;
          margin: 24px auto 0;
          background: url("../../assets/images/playvideo.png");
          background-size: 100% 100%;
          cursor: pointer;
          opacity: 0.5;
        }
      }
    }
  }
  .commonTitle {
    letter-spacing: 3px;
    padding-top: 60px;
    font-size: 30px;
    line-height: 150px;
    text-align: center;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .suite {
    overflow: hidden;

    .title {
      letter-spacing: 3px;
      padding-top: 55px;
      color: #333333;
      text-align: center;
      h1 {
        font-size: 30px;
        line-height: 60px;
      }
      p {
        line-height: 24px;
        color: #666666;
      }
    }
    .content {
      height: 705px;
      background: url("../../assets/images/suitebg.png") no-repeat;
      background-size: 100% 100%;
      .wrapper {
        position: relative;
        .top {
          li {
            position: relative;
            float: left;
            height: 495px;
            width: 446px;
            &:last-child {
              float: right;
              width: 648px;
              img {
                position: absolute;
                top: 0;
                left: 0;
              }
            }
          }
          padding-top: 100px;
        }
        .bottom {
          overflow: hidden;
          ul {
            width: 2401px;
            li {
              float: left;
              width: 171px;
              height: 110px;
              padding-right: 0.5px;
              cursor: pointer;
            }
            transition: all 0.8s linear;
            &.active {
              transform: translateX(-1200.5px);
            }
          }
        }
        .prev,
        .next {
          position: absolute;
          bottom: 20px;
          width: 70px;
          height: 70px;
          line-height: 70px;
          text-align: center;
          border-radius: 50%;
          font-size: 40px;
          color: #a4a5a6;
          background: #ebecee;
          &.disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }
        }
        .prev {
          left: -95px;
        }
        .next {
          right: -95px;
        }
      }
    }
  }
  .advantage {
    .content {
      background: #5a5a5a;
      li {
        float: left;
        box-sizing: border-box;
        width: 12.5%;
        height: 420px;
        padding: 0 0.625%;
        border-right: 1px solid #000000;
        color: #fff;
        overflow: hidden;
        &:last-child {
          border-right: none;
        }
        h1 {
          position: relative;
          padding: 30px 0 10px;
          line-height: 100px;
          font-size: 70px;
          font-weight: bold;
          &::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
            width: 13%;
            height: 10px;
            background: #fff;
          }
        }
        h2 {
          line-height: 60px;
        }
        p {
          line-height: 24px;
          text-align: justify;
        }
        &.active {
          h1 {
            color: #0d66ee;
          }
        }
      }
    }
  }
  .parameter {
    .tabBar {
      width: 870px;
      margin: 0 auto;
      border-bottom: 1px solid #afbbcd;
      font-size: 18px;
      color: #cccccc;
      li {
        float: left;
        width: 290px;
        line-height: 35px;
        text-align: center;
        cursor: pointer;
        &.active {
          color: #333333;
          border-bottom: 3px solid #0d66ee;
        }
      }
    }
    .content {
      position: relative;
      height: 490px;
      img {
        position: absolute;
        top: 85px;
        left: 0;
        right: 0;
        margin: 0 auto;
      }
    }
  }
  .coreModule {
    .content {
      li {
        position: relative;
        float: left;
        width: 380px;
        height: 240px;
        margin: 0 30px 30px 0;
        font-size: 16px;
        color: #ffffff;
        background: #7e7f80;
        transition: 0.3s;
        &:nth-child(3n) {
          margin-right: 0;
        }
        &.active {
          background: #4696f0;
        }
        h1 {
          position: absolute;
          top: -15px;
          left: -15px;
          width: 190px;
          height: 190px;
          line-height: 190px;
          text-align: center;
          font-size: 22px;
          letter-spacing: 3px;
          span {
            padding-left: 5px;
            border-left: 5px solid #0000ff;
          }
        }
        p {
          padding: 50px 20px 0 200px;
          line-height: 26px;
          text-align: justify;
        }
      }
    }
  }
  .ordersuite {
    margin-bottom: 85px;
    .title {
      letter-spacing: 3px;
      padding-top: 55px;
      color: #333333;
      text-align: center;
      h1 {
        font-size: 30px;
        line-height: 60px;
      }
      p {
        line-height: 24px;
        color: #666666;
      }
    }
    .content {
      .el-form {
        padding: 50px 0;
        .el-form-item__label {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
      .el-button {
        display: block;
        margin: 0 auto;
      }
    }
  }
  .my-custom-dialog {
    .el-dialog__header {
      position: absolute;
      top: 0;
      right: 0;
      width: 20px;
      height: 20px;
      padding: 0;
      z-index: 10;
      .el-dialog__headerbtn {
        top: 0;
        left: 0;
        width: 20px;
        height: 20px;
        font-size: 20px;
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    .el-dialog__body {
      padding: 0;
      z-index: 1;
    }
  }
}
</style>
